import { FC, MouseEventHandler } from 'react'

import styled, { css } from 'styled-components'

import CloseIcon from 'src/Assets/Svg/close-cross.svg?react'

export const closeButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 40px;
  border: 1px solid transparent;
  background: transparent;
  color: ${({ theme }) => theme.color.darkGrey};
  cursor: pointer;
  transition: all 0.2s;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: currentColor;
    }
  }

  &:hover {
    background: ${({ theme }) => theme.color.lightGrey};
    color: ${({ theme }) => theme.color.darkGrey};
  }

  &:focus-visible {
    outline: none;
    background: ${({ theme }) => theme.color.white};
    border-color: ${({ theme }) => theme.color.brandGreen};
  }

  &:active {
    background: ${({ theme }) => theme.color.white};
    border-color: transparent;
    color: ${({ theme }) => theme.color.mediumGrey};
  }

  &:disabled {
    cursor: not-allowed;
    background: transparent;
    border-color: transparent;
    color: ${({ theme }) => theme.color.lightGrey};
  }
`

const StyledButton = styled.button`
  ${closeButtonStyles}
`

export interface CloseButtonProps {
  onClick?: MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  className?: string
}

export const CloseButton: FC<CloseButtonProps> = ({
  onClick,
  disabled,
  className,
}) => (
  <StyledButton
    type='button'
    aria-label='Close'
    onClick={onClick}
    disabled={disabled}
    className={className}
  >
    <CloseIcon />
  </StyledButton>
)
